import { useQuery } from '@tanstack/react-query';
import { QUESTIONNAIRE_DETAILS_KEY } from '../../utils/constants/queryKeys';
import { getQuestionnaireDetails } from '../services/fn-api/Questionnaires';

export const useGetQuestionnaireDetails = (questionnaireId: number) => {
  return useQuery({
    queryKey: [QUESTIONNAIRE_DETAILS_KEY, questionnaireId],
    queryFn: () => getQuestionnaireDetails(questionnaireId),
    enabled: !!questionnaireId,
  });
};
